/*
 * ClubMarkers Messages
 *
 * This contains all the text for the ClubMarkers component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  directions: {
    id: 'app.components.ClubMarkers.directions',
    defaultMessage: 'Directions',
  },
  linkTitle: {
    id: 'app.components.ClubMarkers.linkTitle',
    defaultMessage: 'Website of {club}',
  },
  pageTitle: {
    id: 'app.components.ClubMarkers.pageTitle',
    defaultMessage: 'Link to this page',
  },
  startingPoint: {
    id: 'app.components.ClubMarkers.startingPoint',
    defaultMessage: 'Starting Point',
  },
  notFound: {
    id: 'app.components.ClubMarkers.notFound',
    defaultMessage: 'Club {id} could not be found',
  },
  notFoundLocation: {
    id: 'app.components.ClubMarkers.notFoundLocation',
    defaultMessage: 'Location {id} could not be found',
  },
});
